import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { getActivePortal, getActivePortalLoaded, LoadActivePortal } from '../store';

import { CookieConfigService } from '@teamfoster/sdk/cookie-ngrx';

export const ActivePortalGuard: CanActivateFn = () => {
  const store = inject(Store);
  const cookieConfig = inject(CookieConfigService);

  return store
    .select(getActivePortalLoaded)
    .pipe(
      withLatestFrom(store.select(getActivePortal)),
      tap(([loaded, portal]) => {
        if (!loaded) {
          store.dispatch(LoadActivePortal());
        } else {
          cookieConfig.analyticsCode = portal?.analyticsTrackingCode;
          if (portal?.id === 1) {
            cookieConfig.useTagManager = true;
          }
        }
      }),
      filter(([loaded]) => loaded),
      take(1)
    )
    .pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
};
